import React from 'react';
import Module from 'Components/Core/Module';
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import Avatar from 'Components/Member/Avatar';
import DialogSelectText from 'Components/Core/Form/DialogSelectText';
import DialogSetPassword from './DialogSetPassword';
import FormSelectIcon from 'Components/Core/Form/FormSelectIcon';
import 'CSS/Member/MemberProfile.css'

export default function MemberProfile(props) {

    const x = props.x;

	const wafId = props.id;
	const buttons = [];
	const dialogId = "dialog-set-password";
	const wafIdDialog = wafId + '-dialog-set-password';
	const selectMemberLevelId = wafId + '-select-member-level';

	const [memberId, setMemberId] = React.useState(props.memberId);
	const [memberAvatarImage, setMemberAvatarImage] = React.useState('');
	const [memberLevel, setMemberLevel] = React.useState(5);
	const [memberName, setMemberName] = React.useState(props.memberName);
	const [confirmedClass, setConfirmedClass] = React.useState('d-none');
	const [lockClass, setLockClass] = React.useState('d-none');
	const [unlockClass, setUnlockClass] = React.useState('d-none');


	x.wam.init(props.id, {
		"title": 'Profil ',
		"onClose": () => {
			x.waf.destroy(wafId);
			x.waf.destroy(wafIdDialog);
			x.was.removeDialog(dialogId);
		}
	});

	x.waf.init(wafId, {
		"onAfterRead": onAfterRead
	});

	// Module Icons 

	if (x.was.memberLevel === 1) {
		buttons.push(<button type="button" key="confirm" className={`btn ${confirmedClass}`} onClick={confirm} >Anmeldung bestätigen</button>);
		buttons.push(<button type="button" key="lock" className={`btn ${lockClass}`} onClick={lock} >Sperren</button>);
		buttons.push(<button type="button" key="unlock" className={`btn ${unlockClass}`} onClick={unlock} >Freigeben</button>);
		buttons.push(<button type="button" key="anonymize" className="btn " onClick={anonymize} >Mitglied löschen (DSGVO)</button>);
	}
	if (x.was.memberLevel < 3) {
		buttons.push(<button type="button" key="set-password" className="btn " onClick={changePassword} >Kennwort setzen</button>);
	}

	function confirm() {
		x.was.axPost('Backend/webapp.php?module=Member&task=ConfirmMember', { "memberid": memberId }, (result) => {
			if (result.data.returncode === 1) {
				x.waf.set(wafId, 'confirmed', 'Ja', true);
				setConfirmedClass('d-none');
			}
		});
	}

	function lock() {
		x.was.axPost('Backend/webapp.php?module=Member&task=LockMember', { "memberid": memberId }, (result) => {
			if (result.data.returncode === 1) {
				x.waf.set(wafId, 'locked', 'Ja', true);
				setLockClass('d-none');
				setUnlockClass('flex');
			}
		});
	}

	function unlock() {
		x.was.axPost('Backend/webapp.php?module=Member&task=UnlockMember', { "memberid": memberId }, (result) => {
			if (result.data.returncode === 1) {
				x.waf.set(wafId, 'locked', 'Nein', true);
				setLockClass('flex');
				setUnlockClass('d-none');
			}
		});
	}

	function anonymize() {
		x.wau.yesNo(
			'Alle personenbezogenen Daten dieses Mitglieds unwiderruflich löschen (Name, Mail, Passwort, IP-Adressen)? Die Beiträge selbst bleiben inhaltlich erhalten, werden aber einem anonymen Platzhalter zugeordnet.',
			(result) => {
				if (result !== 1) return;
				x.was.axPost('Backend/webapp.php?module=Member&task=AnonymizeMember', { "memberId": memberId }, (result) => {
					if (result.data.returncode === 1) {
						x.wah.addHint('Mitglied wurde anonymisiert.');
						x.wam[props.id].hide();
					}
					else {
						x.wah.addHint('Anonymisieren fehlgeschlagen!', true);
					}
				});
			}
		);
	}

	function saveMemberLevel(memberLevel) {
		x.was.axPost('Backend/webapp.php?module=Member&task=SaveMemberLevel', { "memberId": memberId, "memberLevel": memberLevel }, (result) => {
			if (result.data.returncode === 1) {
				setMemberLevel(memberLevel);
				x.waf.set(wafId, 'memberLevel', x.was.memberLevelLabel[memberLevel], true);
			}
		});
	}

	function changePassword() {
		x.wad[dialogId].show(() => { x.waf.focus(wafIdDialog, 'new-password') });
	}

	function onAfterRead(data) {
		setMemberId(data.content.memberid);
		setMemberName(data.content.membername);
		setMemberLevel(data.content.memberlevel);
		setMemberAvatarImage(data.content.avatarimage);
		x.waf.set(wafId, 'memberId', data.content.memberid, true);
		x.waf.set(wafId, 'memberLevel', x.was.memberLevelLabel[data.content.memberlevel], true);
		x.waf.set(wafId, 'memberName', data.content.membername, true);
		x.waf.set(wafId, 'confirmed', (data.content.confirmed === 1) ? 'Ja' : 'Nein', true);
		x.waf.set(wafId, 'locked', (data.content.locked === 1) ? 'Ja' : 'Nein', true);
		x.waf.set(wafId, 'created', data.content.created, true);
		x.waf.set(wafId, 'postingCount', data.content.postingcount, true);
		x.waf.set(wafId, 'lastLogin', data.content.lastlogin, true);
		x.waf.set(wafId, 'lastRequest', data.content.lastrequest, true);
		if (x.was.memberLevel === 1) {
			x.waf.set(wafId, 'name', data.content.name, true);
			x.waf.set(wafId, 'firstName', data.content.firstname, true);
			x.waf.set(wafId, 'mail', data.content.mail, true);
			x.waf.set(wafId, 'notificationpublic', data.content.notificationpublic, true);
			x.waf.set(wafId, 'notificationprivate', data.content.notificationprivate, true);
			x.waf.set(wafId, 'forumScroll', data.content.forumscroll, true);
			x.waf.set(wafId, 'forumHideImages', data.content.forumhideimages, true);
			x.waf.set(wafId, 'forumHideContent', data.content.forumhidecontent, true);
			x.waf.set(wafId, 'forumHideDiscussion', data.content.forumhidediscussion, true);
			x.waf.set(wafId, 'forumHideAvatar', data.content.forumhideavatar, true);
			x.waf.set(wafId, 'forumHideDate', data.content.forumhidedate, true);
			x.waf.set(wafId, 'forumMemberColored', data.content.forummembercolored, true);
			x.waf.set(wafId, 'forumFontBold', data.content.forumfontbold, true);
			x.waf.set(wafId, 'forumSendWithEnter', data.content.forumsendwithenter, true);
			x.waf.set(wafId, 'darkTheme', data.content.darktheme, true);
			x.waf.set(wafId, 'darkThemeVariant', data.content.darkthemevariant, true);
		}
		if (data.content.confirmed === 0) {
			setConfirmedClass('flex');
		}
		else {
			setConfirmedClass('d-none');
		}
		if (data.content.locked === 0) {
			setLockClass('flex');
			setUnlockClass('d-none');
		}
		else {
			setLockClass('d-none');
			setUnlockClass('flex');
		}
		x.wam.init(props.id, {
			"title": 'Profil: ' + data.content.membername,
		});
	}

	const MemberLevelChangeTag = (x.was.memberLevel === 1) 
		? 
			<FormSelectIcon
				id={selectMemberLevelId}
				wafId={selectMemberLevelId}
				componentId={x.wau.getComponentId()}
				moduleId={props.id}
				x={x}  
				classes="bi bi-pencil module-icon"
				default=""
				defaultKey={0}
				title='Status'
				hiddenInput={true}
				inputIcon='bi-pencil'
				onSelect={(key, value) => {
					saveMemberLevel(key);
				}}
			/>
		:
			null;		

	return (

		<Module id={props.id} x={x}   title={props.title} display={props.display} displayTitle="d-block" classes="module-member-profile" >
			<div id="" className={` member-profile `}>
				<div key="avatar" className='d-flex'>
					<Avatar memberLevel={memberLevel}  avatarText={memberName} image={memberAvatarImage} size="xlarge" />
				</div>
				<Form x={x}
					wafId={wafId}
					module="Member"
					readTask="ReadMemberProfile"
					sendTask={x.was.memberLevel === 1 ? "SaveMemberProfileSettings" : ""}
					addUrl={'memberId=' + memberId}
					focusElement="name"
					classes="member-form"
					sendButton={x.was.memberLevel === 1}
					buttons={buttons}>
					<fieldset className="form-group mb-2">
						<legend className="float-none w-auto">Allgemein</legend>
						<FormElement x={x}   wafId={wafId} disabled={true} id="memberId" title="Mitglied Nr.:" />
						<FormElement x={x}   wafId={wafId} disabled={true} id="memberName" title="Pseudonym:" />
						<FormElement x={x}   wafId={wafId} disabled={true} id="memberLevel" title="Status:">
							{MemberLevelChangeTag}
						</FormElement>
						<FormElement x={x}   wafId={wafId} id="confirmed" disabled={true} title="Bestätigt" />
						<FormElement x={x}   wafId={wafId} id="locked" disabled={true} title="Gesperrt" />
					</fieldset>

					<fieldset key="statistic" className="mb-2">
						<legend>Statistik</legend>
						<FormElement x={x}   wafId={wafId} disabled={true} id="created" title="Konto erstellt am:" />
						<FormElement x={x}   wafId={wafId} disabled={true} id="postingCount" title="Postings:" />
						<FormElement x={x}   wafId={wafId} disabled={true} id="lastLogin" title="Letzte Anmeldung:" />
						<FormElement x={x}   wafId={wafId} disabled={true} id="lastRequest" title="Letzter Zugriff:" />
					</fieldset>

					{x.was.memberLevel === 1 &&
						<>
							<fieldset className="form-group mb-2">
								<legend className="float-none w-auto">Kontaktdaten</legend>
								<FormElement x={x} wafId={wafId} id="name" title="Name" />
								<FormElement x={x} wafId={wafId} id="firstName" title="Vorname" />
								<FormElement x={x} wafId={wafId} id="mail" title="Mail" />
							</fieldset>

							<fieldset className="form-group mb-2">
								<legend className="float-none w-auto">Push-Benachrichtigungen</legend>
								<FormElement type="checkbox" x={x} wafId={wafId} id="notificationpublic" title="Über öffentliche Beiträge informieren" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="notificationprivate" title="Über private Beiträge informieren" />
							</fieldset>

							<fieldset className="mb-2">
								<legend>Forum</legend>
								<FormElement type="checkbox" x={x} wafId={wafId} id="darkTheme" title="Dunkelmodus" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="darkThemeVariant" title="Alternatives Design (Nur Dunkelmodus)" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumScroll" title="Horizontal scrollen" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumHideImages" title="Bilder ausblenden" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumHideContent" title="Inhalte ausblenden" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumHideDiscussion" title="Diskussion ausblenden" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumHideAvatar" title="Avatar ausblenden" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumHideDate" title="Datum ausblenden" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumMemberColored" title="Name des Verfassers farbig anzeigen" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumFontBold" title="Fette Schrift" />
								<FormElement type="checkbox" x={x} wafId={wafId} id="forumSendWithEnter" title="Posting mit Enter senden" />
							</fieldset>
						</>
					}
				</Form>
			</div>
			<DialogSetPassword id={dialogId} memberId={memberId} x={x}   wafId={wafIdDialog} />
			<DialogSelectText 
				id={selectMemberLevelId} 
				moduleId={props.id} 
				x={x}   
				classes="dialog-select-member-level"
				onSetData={() => {
					const data = 
					[
						{'id': 1, 'name': x.was.memberLevelLabel[1]},
						{'id': 2, 'name': x.was.memberLevelLabel[2]},
						{'id': 3, 'name': x.was.memberLevelLabel[3]},
						{'id': 4, 'name': x.was.memberLevelLabel[4]}
					]
					return data;
				}}
				title="Status" 
			/>

		</Module>

	)
};
